import axios from "axios";
import Cookies from 'js-cookie';
export const apiClient = axios.create(
    {
        baseURL: process.env.REACT_APP_API_URL,
    }
);
apiClient.interceptors.response.use((response) => response, (error) => {
    // if (error?.response?.status === 403) {
    //     Cookies.set('_auth', '', {expires: new Date()})
    //     Cookies.set('_auth_state', '', {expires: new Date()})
    //     Cookies.set('_auth_storage', '', {expires: new Date()})
    //     Cookies.set('_auth_type', '', {expires: new Date()})
    //     window.location.replace('/login')
    // }
    throw error;
});